// extracted by mini-css-extract-plugin
module.exports = {"modal_body":"modal_body--DemoPost-modals-components__3hrFj","modalBody":"modal_body--DemoPost-modals-components__3hrFj","button":"button--DemoPost-modals-components__3gGUi"};